import SingleEpl from './SingleEpl'
import './SingleEpl.sass'

export default SingleEpl
